{
  "seo": {
    "title": "Welcome - Set Up Your Family",
    "description": "Set up your family in CuriPop by adding your first child profile and choosing your plan."
  },
  "states": {
    "preparing": "Preparing your family setup..."
  },
  "steps": {
    "labels": {
      "welcome": "Welcome",
      "addChild": "Add child",
      "choosePlan": "Choose plan"
    },
    "welcome": {
      "title": "Welcome!",
      "titleNamed": "Welcome, {name}!",
      "subtitle": "Your parent account is ready. Next, add your first child profile so we can personalize questions and reading levels.",
      "bullets": {
        "personalized": "Personalized content by age and grade",
        "accessCode": "Family access code for kid-friendly login",
        "dashboard": "Parent dashboard to track learning progress"
      },
      "cta": "Continue setup"
    },
    "addChild": {
      "title": "Add your first child"
    },
    "choosePlan": {
      "title": "Choose your next step",
      "subtitle": "Great, your child profile is ready. You can continue with the free experience now, or unlock the full family plan.",
      "free": "Continue with Free",
      "trial": "Start Family Trial",
      "note": "Not ready yet? You can always manage plans later from the parent dashboard.",
      "cta": "Go to dashboard"
    }
  },
  "form": {
    "labels": {
      "nickname": "Nickname",
      "grade": "Grade",
      "pin": "Optional 4-digit PIN"
    },
    "placeholders": {
      "nickname": "e.g. Leo",
      "pin": "1234"
    },
    "preschool": "Preschool",
    "grade": "Grade {grade}",
    "actions": {
      "back": "Back",
      "creating": "Creating profile...",
      "create": "Create child profile"
    },
    "errors": {
      "nicknameLength": "Nickname must be between 2 and 20 characters.",
      "pinLength": "PIN must be exactly 4 digits.",
      "createChild": "We couldn't create the child profile. Please try again."
    }
  }
}
